const haveVwo = computed(async () => {
  return await RsvpUtil.fluidWait({
    predicate: () => !!window.VWO,
    timeout: 5000,
    minWait: 1000,
  });
});

export const useVwoTest = () => {
  return { haveVwo };
};
